import Loadable from "@loadable/component";

//export const loadableShader = Loadable(() => import('@signal-noise/react-shader-canvas'));

export const loadableP5 = Loadable(() => import('react-p5-wrapper'));